import { AccessTime, Route } from '@mui/icons-material';
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import { Colors } from '../../../assets/theme/Colors';

const RouteCard = ({
  title,
  color = '#2561e9',
  formattedDays = [],
  pickups,
  dropoffs,
  startTime,
  endTime,
  distance = 0,
  duration = 0,
  onClick,
}) => {
  const timeRange = `${moment(startTime, 'HH:mm').format('hh:mm A')} - ${moment(endTime, 'HH:mm').format('hh:mm A')}`;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', ml: 0.5, mb: 1 }}>
      <Card
        variant="outlined"
        onClick={onClick}
        sx={{
          width: '245px',
          borderRadius: 2,
          position: 'relative',
          border: 'none',
          cursor: 'pointer',
          boxShadow: 1,
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        <CardContent
          sx={{
            py: 1,
            pl: 2,
            pr: 1,
            '&:last-child': {
              pb: 1,
            },
            '&:before': {
              position: 'absolute',
              zIndex: 0,
              top: 0,
              left: 0,
              width: '6px',
              height: '100%',
              content: '""',
              borderTopLeftRadius: 2,
              borderBottomLeftRadius: 2,
              backgroundColor: color || '',
            },
          }}
        >
          {/* route name */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: color,
                flexShrink: 0,
              }}
            />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
          </Box>

          {/* time range */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              color: 'text.secondary',
              mb: 1,
            }}
          >
            <AccessTime sx={{ fontSize: 12 }} />
            <Typography variant="caption">
              {timeRange}
              {formattedDays.length > 0 && ` · ${formattedDays.join(' · ')}`}
            </Typography>
          </Box>

          {/* chips */}
          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <Chip
              size="small"
              label={`${pickups} pickup${pickups === 1 ? '' : 's'}`}
              sx={{
                bgcolor: '#d9e6e7',
                color: Colors.primaryColor,
                fontWeight: 700,
                '& .MuiChip-label': { px: 1.25 },
              }}
              icon={
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: Colors.primaryColor,
                    ml: '8px !important',
                  }}
                />
              }
            />
            <Chip
              size="small"
              label={`${dropoffs} drop-off${dropoffs === 1 ? '' : 's'}`}
              sx={{
                bgcolor: '#fdeae1',
                color: Colors.appBar.main,
                fontWeight: 700,
                '& .MuiChip-label': { px: 1.25 },
              }}
              icon={
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: Colors.appBar.main,
                    ml: '8px !important',
                  }}
                />
              }
            />
          </Box>

          {/* distance and duration */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              color: 'text.secondary',
            }}
          >
            <Route sx={{ fontSize: 12 }} />
            <Typography variant="caption">
              {distance ? `${(distance / 1609.34).toFixed(0)} mi` : ''}{' '}
              {duration ? `· ${(duration / 60).toFixed(0)} min` : ''}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RouteCard;
